import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-square-export-lined",
  "use": "rt-base-square-export-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-square-export-lined\"><path d=\"M896.4 767.6h-56c-4.4 0-8 3.6-8 8V840H176.9V184h655.6v64.4c0 4.4 3.6 8 8 8h56c4.4 0 8-3.5 8-8V144c0-17.7-14.3-32-32-32H137c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h735.5c17.7 0 32-14.3 32-32V775.6c0-4.4-3.7-8-8.1-8z\" /><path d=\"M915.8 505.4L768.1 388.8c-5.5-4.4-13.5-0.4-13.5 6.6v79.2H427.7c-4.6 0-8.3 3.8-8.3 8.3v58.3c0 4.6 3.7 8.3 8.3 8.3h326.9v79.2c0 7 8.1 10.9 13.5 6.6l147.7-116.7c4.3-3.4 4.3-9.8 0-13.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/square-export-lined.svg
// module id = 1794
// module chunks = 137